var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.roles && _vm.roles.length)?_c('ul',{staticClass:"rp-sidebar-roles-list"},_vm._l((_vm.sortedRoles),function(role){return _c('li',{key:role.id,class:[
      'rp-sidebar-roles-list__item',
      { active: role.id === _vm.activeRoleId }
    ],on:{"click":function($event){return _vm.editRole(role)}}},[_c('r-text',{staticStyle:{"text-transform":"capitalize"},attrs:{"type":"caption","color-type":"primary"}},[_vm._v(" "+_vm._s(role.name)+" ")])],1)}),0):_c('div',{staticClass:"rp-sidebar-roles-list__no-data"},[_c('r-text',[_vm._v("Нет данных")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }